import { Channel } from '../models';

export function isChannelConnected(channel: Channel): boolean {
  return Boolean(channel.subscriblyChannel?.id);
}

export function isChannelExpired(channel: Channel): boolean {
  if (!channel.subscriblyChannel) {
    return true;
  }

  return new Date(channel.subscriblyChannel.expiresAt) < new Date();
}

export function extractChannelHandle(url: string): string {
  const patterns = [
    // Meta
    {
      domain: 'facebook.com',
      regex: /facebook\.com\/(?:profile\.php\?id=)?([^/?]+)/,
      prefix: '@',
    },
    { domain: 'instagram.com', regex: /instagram\.com\/([^/?]+)/, prefix: '@' },
    { domain: 'threads.net', regex: /threads\.net\/@?([^/?]+)/, prefix: '@' },
    { domain: 'threads.com', regex: /threads\.com\/@?([^/?]+)/, prefix: '@' },

    // Bluesky / Mastodon (Fediverse-style)
    { domain: 'bsky.app', regex: /bsky\.app\/profile\/([^/?]+)/, prefix: '@' },
    { domain: 'mastodon.', regex: /mastodon\.[^/]+\/@([^/?]+)/, prefix: '@' },

    // Pinterest
    { domain: 'pinterest.', regex: /pinterest\.[^/]+\/([^/?]+)/, prefix: '@' },

    // Twitter / X
    { domain: 'twitter.com', regex: /twitter\.com\/@?([^/?]+)/, prefix: '@' },
    { domain: 'x.com', regex: /x\.com\/@?([^/?]+)/, prefix: '@' },

    // LinkedIn
    {
      domain: 'linkedin.com',
      regex: /linkedin\.com\/(?:in|company)\/([^/?]+)/,
      prefix: '@',
    },

    // YouTube
    {
      domain: 'youtube.com',
      regex: /youtube\.com\/(?:@|c\/|user\/)?([^/?]+)/,
      prefix: '@',
    },
    { domain: 'youtu.be', regex: /youtu\.be\/([^/?]+)/, prefix: '@' },

    // TikTok
    { domain: 'tiktok.com', regex: /tiktok\.com\/@([^/?]+)/, prefix: '@' },

    // Snapchat
    {
      domain: 'snapchat.com',
      regex: /snapchat\.com\/add\/([^/?]+)/,
      prefix: '@',
    },

    // Twitch
    { domain: 'twitch.tv', regex: /twitch\.tv\/([^/?]+)/, prefix: '@' },

    // Discord
    { domain: 'discord.gg', regex: /discord\.gg\/([^/?]+)/, prefix: '' }, // invite link
    {
      domain: 'discord.com',
      regex: /discord\.com\/users\/([^/?]+)/,
      prefix: '@',
    },

    // Slack
    { domain: 'slack.com', regex: /([a-zA-Z0-9_-]+)\.slack\.com/, prefix: '' },

    // Google My Business (aka Google Maps business)
    { domain: 'goo.gl/maps', regex: /goo\.gl\/maps\/([^/?]+)/, prefix: '' },
    {
      domain: 'google.com/maps',
      regex: /google\.com\/maps\/place\/([^/?]+)/,
      prefix: '',
    },
  ];
  for (const { domain, regex, prefix } of patterns) {
    if (url.includes(domain)) {
      const match = url.match(regex);
      if (match) return prefix + match[1];
    }
  }
  return ''; // unknown platform or invalid URL
}
